// Shared layout for the Discovery and Strategy meeting forms.
// Renders the prospect header (name + save indicator) and a back link
// to the Pipeline. Children render below as the form body.

import { Link } from 'react-router-dom';

function formatTime(d) {
  return d ? d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit' }) : '';
}

export default function MeetingFormLayout({
  title,
  prospect,
  savedAt,
  saving,
  loadError,
  saveError,
  children,
}) {
  return (
    <div className="space-y-4">
      {/* Header card with prospect identity + save status */}
      <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] px-5 py-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1 min-w-0">
            <Link to="/crm" className="text-[11px] text-bullogic-blue hover:underline">← Back to Pipeline</Link>
            <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#888] mt-1">{title}</div>
            <h1 className="text-[22px] font-bold text-navy mt-0.5 truncate">
              {prospect ? prospect.name : 'Loading…'}
            </h1>
            {prospect && (
              <div className="text-[11px] text-[#666] mt-0.5">
                {prospect.serviceTier && <span className="mr-3">Tier: {prospect.serviceTier}</span>}
                {prospect.stage && <span className="mr-3">Stage: {prospect.stage}</span>}
                {prospect.source && <span>Source: {prospect.source}</span>}
              </div>
            )}
          </div>
          <div className="text-right shrink-0">
            {saving ? (
              <span className="text-[11px] text-amber-600 font-bold">Saving…</span>
            ) : savedAt ? (
              <span className="text-[11px] text-deep-teal">✓ Saved {formatTime(savedAt)}</span>
            ) : (
              <span className="text-[11px] text-[#aaa]">No changes yet</span>
            )}
            <div className="text-[10px] text-[#aaa] mt-0.5">Auto-saves every change</div>
          </div>
        </div>
        {loadError && (
          <div className="mt-3 text-[11px] text-rose">Failed to load saved notes: {loadError}</div>
        )}
        {saveError && (
          <div className="mt-3 text-[11px] text-rose">Last save failed: {saveError} — your local edits are preserved; keep typing to retry.</div>
        )}
      </div>

      {children}
    </div>
  );
}
